import React from 'react';
import TraiteurApp from './components/TraiteurApp';
import './App.css';

function App() {
  return (
    <div className="App">
      <TraiteurApp />
    </div>
  );
}

export default App;